module.exports = __webpack_public_path__ + "static/candidate-df98e6b4866f7ca2a1f98ea664d2b36f.png";